import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { User } from '@/components/atoms/AppIcon';
import { AppButton } from '../atoms';
import { TENANT_ROUTES } from '@/constants/routes';
import { useClinicContext } from '@/hooks/main/useClinicContext';

export const buildPatientEditHref = (tenant: string, patientId: number): string =>
  TENANT_ROUTES.PATIENTS.EDIT_BY_ID(tenant, patientId);

interface PatientEditLinkProps {
  patientId: number;
  value?: React.ReactNode;
  fallback?: React.ReactNode;
  className?: string;
  ariaLabel?: string;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
  stopPropagation?: boolean;
}

const PatientEditLink: React.FC<PatientEditLinkProps> = ({
  patientId,
  value,
  fallback = '—',
  className = 'inline-flex items-center gap-1',
  ariaLabel = '受診者編集',
  target,
  rel,
  stopPropagation = false,
}) => {
  const { tenant } = useClinicContext();
  const content = value ?? fallback;
  const path = buildPatientEditHref(tenant, patientId);

  const handleLinkClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (stopPropagation) {
        event.stopPropagation();
      }
    },
    [stopPropagation]
  );

  return (
    <span className={className}>
      <Link
        to={path}
        target={target}
        rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)}
        aria-label={ariaLabel}
        onClick={handleLinkClick}
      >
        <AppButton type="default" size="small" className="min-w-0 w-7 h-7">
          <User />
        </AppButton>
      </Link>
      <span className="cursor-text">{content}</span>
    </span>
  );
};

export default PatientEditLink;
